import React from 'react';
import { motion } from 'framer-motion';
import styles from './Hero.module.css';
import heroBg from '../../assets/hero.jpg';

export default function Hero() {
  const go = (e, href) => {
    e.preventDefault();
    document.querySelector(href)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className={styles.hero}>
      <div className={styles.bg} style={{ backgroundImage: `url(${heroBg})` }} />
      <div className={styles.overlay} />

      {/* Diagonal accent bar */}
      <div className={styles.accentBar} />

      <div className={styles.content}>
        <motion.div
          className={styles.eyebrow}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <span className={styles.eyebrowLine} />
          Licensed & Incorporated · Vancouver, BC
          <span className={styles.eyebrowLine} />
        </motion.div>

        <motion.h1
          className={styles.heading}
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          Built Right.<br />
          <span className={styles.headingAccent}>Built to Last.</span>
        </motion.h1>

        <motion.p
          className={styles.sub}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.75 }}
        >
          AussieSpec Structures delivers expert renovations, framing, cladding,
          waterproofing, Hardie board, stucco, stone and finishing carpentry
          across the Lower Mainland.
        </motion.p>

        <motion.div
          className={styles.ctas}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.95 }}
        >
          <a href="#contact" className={styles.ctaPrimary} onClick={e => go(e, '#contact')}>
            Get a Free Quote
          </a>
          <a href="#services" className={styles.ctaSecondary} onClick={e => go(e, '#services')}>
            Our Services
          </a>
        </motion.div>

        <motion.div
          className={styles.badges}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
        >
          {['BC Incorporated', 'Fully Insured', 'Free Estimates', 'Quality Guaranteed'].map(b => (
            <span key={b} className={styles.badge}>
              <span className={styles.badgeCheck}>✓</span> {b}
            </span>
          ))}
        </motion.div>
      </div>

      {/* Bottom strip */}
      <div className={styles.strip}>
        {['Renovations', 'Framing', 'Cladding', 'Waterproofing', 'Hardie Board', 'Stucco', 'Natural Stone', 'Carpentry'].map((s, i) => (
          <React.Fragment key={s}>
            <span>{s}</span>
            {i < 7 && <span className={styles.stripDot}>◆</span>}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
}
